import { baseUrl } from '@/common/settings';
import { getDataNoFilter, getDataRes, postData } from '@/api/common/useRequest';
import { getDomains, getSchemaByEntityId, mergeDomainsInSchema } from '@/utils/odataUtilCommon';
const env = process.env;
// 下载跟路径
export const downloadBase = 'integration-api' + baseUrl;
/**
 * 假分页
 */
export function handleSearchLocal(pageInfo) {
  if (pageInfo.all && pageInfo.all.length > 0) {
    let curent = 0;
    if (pageInfo.currentPage > 1) {
      curent = (pageInfo.currentPage - 1) * pageInfo.pagesize;
    }
    // 裁剪一下数组
    const result = pageInfo.all.slice(curent, curent + pageInfo.pagesize);
    pageInfo.total = pageInfo.all.length;
    pageInfo.list = result;
  } else if (pageInfo.all.length === 0) {
    pageInfo.total = 0;
    pageInfo.list = [];
  }
}
/**
 * 获取下载的地址
 * type 1：非excel  默认：excel
 */
export function getDownloadUrl(serviceId, form, likeArray, dateArray, type) {
  const conditions = {
    likeArray,
    dateArray
  };
  const sapClient = env.VUE_APP_SAP_CLIENT;
  let url = '';
  if (type === 1) {
    url = downloadBase + serviceId + form + '?sap-client=' + sapClient;
  } else {
    url = downloadBase + serviceId + '/FileSet' + '(\'\')/$value?sap-client=' + sapClient + '&filter=' + makeQuery(form, conditions);
  }
  return url;
}
/**
 * 特殊下载
 * $filter=Data eq '{"Operation":"GetList","Flms":"","Erdat":"","ResultSet":[{"Posid1":"106083001"}]}'
 */
export function getDownloadPlanUrl(serviceId, form) {
  const sapClient = env.VUE_APP_SAP_CLIENT;
  const url = downloadBase + serviceId + form + '&sap-client=' + sapClient;
  return url;
}
/**
 * 拼接查询请求
 * @param obj
 * @param conditions 查询条件
 */
export function makeQuery(obj, conditions) {
  const likeArray = conditions.likeArray ? conditions.likeArray : []; // 模糊查询数组
  const dateArray = conditions.dateArray ? conditions.dateArray : []; // 时间间隔查询数组
  const neArray = conditions.neArray ? conditions.neArray : []; // 排除数组
  const dateSearch = conditions.dateSearch ? conditions.dateSearch : []; // 时间查询
  const leSearch = conditions.leSearch ? conditions.leSearch : []; // 小于等于
  const geSearch = conditions.geSearch ? conditions.geSearch : []; // 大于等于
  let query = '';
  for (const key in obj) {
    if (obj[key]) {
      if (dateArray.indexOf(key) > -1) {
        // 处理时间
        const before = obj[key][0];
        const after = obj[key][1];
        if (before && after) {
          query += '(' + key + ' ge datetime\'' + before + 'T00:00:00\' and ' + key + ' le datetime\'' + after + 'T23:59:59\') and ';
        }
      } else if (dateSearch.indexOf(key) > -1) {
        // 处理时间
        query += key + ' ge datetime\'' + obj[key] + 'T00:00:00\'  and ';
      } else if (neArray.indexOf(key) > -1) {
        query += '(';
        for (const data of obj[key]) {
          query += key + ' ne \'' + data + '\' or ';
        }
        if (query.endsWith(' or ')) {
          query = query.substring(0, query.length - 4);
        }
        query += ') and ';
      } else if (likeArray.indexOf(key) > -1) {
        query += 'substringof(\'' + obj[key] + '\',' + key + ') and ';
      } else if (obj[key] instanceof Array) {
        query += '(';
        for (const data of obj[key]) {
          query += key + ' eq \'' + data + '\' or ';
        }
        if (query.endsWith(' or ')) {
          query = query.substring(0, query.length - 4);
        }
        query += ') and ';
      } else if (leSearch.indexOf(key) > -1) {
        query += key + ' le ' + obj[key] + ' and ';
      } else if (geSearch.indexOf(key) > -1) {
        query += key + ' ge ' + obj[key] + ' and ';
      } else {
        const val = obj[key];
        const quote = typeof val === 'number' ? '' : "'";
        query += key + ` eq ${quote}${val}${quote} and `;
      }
    }
  }
  if (query.endsWith(' and ')) {
    query = query.substring(0, query.length - 5);
  }
  return query;
}
/**
 * 页面查询列表
 *
 * @param obj
 * @param pageCount
 * @param pageSize
 * @param serviceID
 * @param entitySet
 * @param conditions 条件对象
 */
export function getList(obj, pageCount, pageSize, serviceID, entitySet, conditions) {
  const params = makeQueryUrl(obj, conditions, pageCount, pageSize);
  return getDataRes(serviceID, entitySet, params);
}
/**
 * 拼接url
 * @param obj
 * @param conditions
 * @param pageCount
 * @param pageSize
 */
function makeQueryUrl(obj, conditions, pageCount, pageSize) {
  let params = makeQuery(obj, conditions) + '&$format=json&$skip=' + pageCount + '&$top=' + pageSize;
  if (conditions.special) {
    params = params + conditions.special;
  }
  return params;
}
/**
 * 页面查询列表V2
 *
 * @param obj
 * @param page
 * @param serviceID
 * @param entitySet
 * @param conditions
 */
export async function getListPage(obj, page, serviceID, entitySet, conditions) {
  let curent = 0;
  if (page.currentPage > 1) {
    curent = (page.currentPage - 1) * page.pagesize;
  }
  const params = makeQueryUrl(obj, conditions, curent, page.pagesize);
  const result = await getDataRes(serviceID, entitySet, params);
  const total = result.d.count || result.d.results.length;
  page.total = Number(total);
  // tabs
  if (page.titleBase) {
    page.titleShow = page.titleBase + '(' + page.total + ')';
  }
  if (page.all) {
    // 假分页
    page.all = result.d.results;
  } else {
    page.list = result.d.results;
  }
  return result;
}
// 获取阈值
export function getDomainList(serviceID, entitySet) {
  return getDomains(serviceID, entitySet);
}
// 通用post请求
export function post(serviceID, entitySet, data) {
  return postData(serviceID, entitySet, data);
}
// 通用get请求
export function get(serviceID, entitySet) {
  return getDataNoFilter(serviceID, entitySet);
}
// 通用get请求
export function getParam(serviceID, entitySet, param, header) {
  return getDataRes(serviceID, entitySet, param, header);
}
/**
 * 获取Schema,赋值
 */
export const getSchema = async (obj, totalList, SERVICE_ID, ENTITY_ID) => {
  obj.schema = await getSchemaByEntityId(SERVICE_ID, ENTITY_ID);
  obj.schema.properties = mergeDomainsInSchema(obj.schema, totalList);
  return true;
};